// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'controllers'
import fullpage from 'fullpage.js/dist/fullpage.js'
import Masonry from 'masonry-layout'
import SliderBar from 'before-after-slider'
import "@fortawesome/fontawesome-free/js/all"

require('fullpage.js/dist/fullpage.css')

function initFullpage() {
  if ( document.querySelectorAll('#fullpage .section').length ) {
    new fullpage('#fullpage')  
  }
}

function imageSwitch() {
  const projects = document.querySelectorAll('.project-index')

  projects.forEach((project) => {
    const interval = project.dataset.interval
    const images = project.querySelectorAll('img')
    let active = 0

    if (interval > 0 && images.length > 1 && !project.classList.contains('switch-loaded')) {
      project.style.height = images[active].offsetHeight + 'px'
      project.parentElement.style.height = images[active].offsetHeight + 'px'
      
      setInterval(() => {
        images[active].style.display = 'none'
        active = (++active > images.length - 1) ? 0 : active
        images[active].style.display = 'block'
      }, interval)
      project.classList.add('switch-loaded')
    }
  })
}

window.imageSwitch = imageSwitch

function goToTop() {
  const goToTopButton = document.querySelector('.go-to-top')

  if ( goToTopButton ) {
    goToTopButton.addEventListener('click', function() {
      scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
  }
}

function removeLoader() {
  const loader = document.getElementById('loader')
  
  let opacity = new Promise(function(resolve, reject) {
    loader.style.opacity = 0
    setTimeout(function() {
      resolve()
    }, 600)
  })

  opacity.then(
    function() { loader.remove() }
  )
}

function initMasonry() {
  const productsGrid = document.querySelector('.projects-grid')

  if ( productsGrid ) {
    const masonry = new Masonry(productsGrid, {
      itemSelector: '.project-index'
    })
    window.masonry = masonry
  }
}

function initBeforeAfter() {
  const beforeAfterElements = document.querySelectorAll('.beforeafter')

  beforeAfterElements.forEach((element) => {
    if ( window.outerWidth > 760 ) {
      new SliderBar({
        el: '#' + element.id,
        beforeImg: element.dataset.before,
        afterImg: element.dataset.after,
        height: '700px',
        line: true,
        lineColor: '#7f7f7f'
      })
    } else {
      new SliderBar({
        el: '#' + element.id,
        beforeImg: element.dataset.before,
        afterImg: element.dataset.after,
        height: '250px',
        line: true,
        lineColor: '#7f7f7f'
      })
    }
  })
}

function initMobileMenu() {
  const burger = document.querySelector('.burger')
  const header = document.querySelector('header')

  burger.addEventListener('click', () => {
    header.classList.toggle('open')
  })
}

window.addEventListener('load', () => {
  initFullpage()
  imageSwitch()
  goToTop()
  initMasonry()
  initBeforeAfter()
  initMobileMenu()
  removeLoader()
})